import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Try to find the main scrollable container first
    const mainContent = document.querySelector(".flex-1.overflow-auto");

    if (mainContent) {
      // Scroll the main content container instantly
      mainContent.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
      });
    } else {
      // Fallback to window scroll instantly
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
      });
    }
  }, [location.pathname]);
};

export default useScrollToTop;
